import styled from "styled-components";

const Container = styled.div`
    position: absolute !important;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    gap: 6rem;

    pointer-events: none;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    z-index: 5;

    img {
    }
    .one img {
        left: 2rem;
    }

    .two img {
        left: -2rem;
        transform: rotate(-30deg);
        top: -2.85rem;
    }

    > div {
        user-select: none;
        position: relative;
        pointer-events: all;
        filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.25));

        img {
            position: absolute;
            height: 8.75rem;
            top: -4rem;
        }

        .pill {
            cursor: pointer;
            position: relative;
            right: -1rem;
            color: #fff;
            font-family: "Professor Marbles 3";
            font-size: 2.40881rem;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.12044rem;
            padding: 0 1rem;
            padding-top: 0.5rem;
            padding-right: 2rem;

            background-color: var(--lemonade);
            border-radius: 1.5rem;
            transition: 0.3s;

            transform: rotate(-4deg);

            &.blue {
                background-color: var(--dark-blue);
            }

            &.green {
                right: -8rem;
                bottom: .4rem;
            }

            &:hover {
                transform: rotate(-2deg) scale(1.1);
                z-index: 2;
            }
        }
    }

    @media (max-width: 1000px) {
        visibility: hidden;
    }
`;

export const BuyOverlay = () => {
    return null
    return (
        <Container>
            <div className="one">
                <img src="/overlay/1.png" alt="" className="no-shadow" />
                <div className="pill green">Compre</div>
                <div className="pill blue">Seu ingresso</div>
            </div>
            <div className="two">
                <img src="/overlay/2.png" alt="" className="no-shadow" />
                <div className="pill green">Compre</div>
                <div className="pill blue">Seu ingresso</div>
            </div>
        </Container>
    );
};
